import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import PhoneLink from 'components/common/PhoneLink'
import Media from 'components/common/Media'
import Theme from 'components/common/Theme/Theme'
import Icon from 'components/common/Icon/Icon'
import Link from 'components/common/Link/Link'
import Button from 'components/common/Button/Button'
import LocallyOwnedSvg from 'components/CareersPage/assets/Locally-Owned.svg'
import { VerticalSeparator } from 'components/common/Separator/Separator'

const StoreDetails = ({
  storeNumber,
  storePhoneNumber = '',
  storeFormattedPhone = '',
  storeStreetAddress = '',
  storeCityAddress = '',
  storeDetailsUrl = '',
  handleStoreLocationClick
}) =>
  <Fragment>
    <StoreNumber>
      <LocationIcon alt="" asset="location" />
      My Store: {
        storeNumber
          ? `#${storeNumber}`
          : <LinkButton link data-at-change-store-link onClick={ handleStoreLocationClick }>Choose Store</LinkButton>
      }
    </StoreNumber>
    { storeNumber &&
    <Fragment>
      <StoreWrapper>
        <LocallyOwnedImage />
        <StoreAddressWrapper>
          <StoreAddress>{ storeStreetAddress }</StoreAddress>
          <StoreAddress>{ storeCityAddress }</StoreAddress>
        </StoreAddressWrapper>
      </StoreWrapper>
      <Media.Mobile>
        <StorePhoneLink number={ storePhoneNumber } >
          <PhoneIcon asset="phone-blue" height={ 13 } width={ 13 } />
          {storeFormattedPhone}
        </StorePhoneLink>
      </Media.Mobile>
      <Media.Desktop>
        <StorePhone aria-label={ `Call store ${storeFormattedPhone}` }>{ storeFormattedPhone }</StorePhone>
      </Media.Desktop>
      <LinkWrapper>
        <StoreLink data-at-store-details-link target="_blank" to={ storeDetailsUrl }>
          View Store Details
        </StoreLink>
        <VerticalSeparator />
        <ChangeStoreLink link data-at-change-store-link onClick={ handleStoreLocationClick }>
          Change Store
        </ChangeStoreLink>
      </LinkWrapper>
    </Fragment>
    }
  </Fragment>

StoreDetails.propTypes = {
  handleStoreLocationClick: PropTypes.func,
  storeCityAddress: PropTypes.string,
  storeDetailsUrl: PropTypes.string,
  storeFormattedPhone: PropTypes.string,
  storeNumber: PropTypes.string,
  storePhoneNumber: PropTypes.string,
  storeStreetAddress: PropTypes.string
}

export default StoreDetails

const LinkButton = styled(Button)`
  padding: 0 !important;

  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`

const StoreLink = styled(Link)`
  font-size: 13px;
  line-height: 15px;
`

const StoreNumber = styled.span`
  display: block;
  font-size: 14px;
`

const LocationIcon = styled(Icon)`
  margin-right: 8px;
  width: 10px;
  height: 14px;
`

const StoreWrapper = styled.div`
  display: flex;
  margin: 13px 0 5px;
`

const StoreAddressWrapper = styled.span`
  display: block;
  margin: 10px 0;
`

const StoreAddress = styled.span`
  display: block;
  ${Mixin.font.GothamBold(16)}
  word-wrap: break-word;
`

const StorePhone = styled.button`
  ${Mixin.font.GothamBold(14)}
  border: none;
  background: ${Theme.colors.white};
`

const StorePhoneLink = styled(PhoneLink)`
  display: block;
  ${Mixin.font.GothamBold(14)}
`

const LinkWrapper = styled.div`
  margin-top: 15px;
  display: flex;
`

const ChangeStoreLink = styled(LinkButton)`
  font-size: 13px !important;
  font-weight: normal !important;
  ${Mixin.font.GothamBook()}
`

const LocallyOwnedImage = styled.div`
  background: url(${LocallyOwnedSvg}) center / contain no-repeat;
  width: 84px;
  height: 54px;
  margin-right: 15px;
`

const PhoneIcon = styled(Icon)`
  margin: 0 5px 0 0;
`
